
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Breadcrumbs from './breadcrumbs.vue'
import Header from './header.vue'
import Content from './plp-content'
import BackToTop from './backtotop.vue'
import Footer from './footer.vue'

export default {
  components: {
    Breadcrumbs,
    Header,
    Content,
    BackToTop,
    Footer,
  },
  data: () => ({
    pageHasLoaded: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchParameterString: 'search/getSearchParameterString',
      vxGetPlpScrollPosition: 'search/getPlpScrollPosition',
      vxIsReady: 'search/getIsReady',
    }),
  },
  watch: {
    vxSearchParameterString() {
      if (!this.vxIsReady) return
      this.$router.push(`${this.$route.path}?${this.vxSearchParameterString}`)
    },
  },
  async mounted() {
    try {
      await this.$store.commit('search/setIsReady', false)
      await this.extractQueryParameters()
      await this.vxQuerySearchspring()
      this.pageHasLoaded = true
      await this.$store.commit('search/setIsReady', true)
    } catch (err) {
      this.$sentryException(err, {
        source: 'Searchspring search component',
        level: 'danger',
        extra: 'Failed to setup page',
      })
    }

    // BIND SCROLL EVENT
    window.addEventListener('scroll', this.handleScroll)
    if (this.vxGetPlpScrollPosition) {
      window.scrollTo(0, this.vxGetPlpScrollPosition)
    }
  },
  async beforeDestroy() {
    try {
      await this.$store.commit('search/setIsReady', false)
    } catch (err) {
      this.$sentryException(err, {
        source: 'Searchspring search component',
        level: 'danger',
        extra: 'clear on destroy',
      })
    }
    // UNBIND SCROLL EVENT
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetSearchPage: 'search/setSearchPage',
      vxAddSearchFilter: 'search/addSearchFilter',
      vxSetSearchParameters: 'search/setSearchParameters',
      vxSetPlpScrollPosition: 'search/setPlpScrollPosition',
    }),
    extractQueryParameters() {
      const urlPieces = this.$route.fullPath.split('?')

      if (!urlPieces[1]) return

      const paramters = urlPieces[1].split('&')

      paramters.forEach((parameter) => {
        const decodedParameter = decodeURIComponent(parameter)
        const parameterPieces = decodedParameter.split('=')
        const field = parameterPieces[0]
        const value = parameterPieces[1]

        if (field === 'filter.ss_final_price.low') {
          this.vxSetSearchParameters({
            price: {
              low: parseInt(value),
            },
          })
        } else if (field === 'filter.ss_final_price.high') {
          this.vxSetSearchParameters({
            price: {
              high: parseInt(value),
            },
          })
        } else if (field === 'page') {
          this.vxSetSearchPage(parseInt(value))
          this.vxSetSearchParameters({
            page: parseInt(value),
          })
        } else if (field.includes('sort.')) {
          this.vxSetSearchParameters({
            sort: {
              field: field.replace('sort.', ''),
              direction: value,
              label: '',
            },
          })
        } else if (field === 'q') {
          this.vxSetSearchParameters({
            query: value,
          })
        } else {
          this.vxAddSearchFilter(decodedParameter)
        }
      })
    },
    handleScroll() {
      this.vxSetPlpScrollPosition(window.scrollY)
    },
  },
}
